export enum LOGINCOMPONENTTYPE {
  LOGIN = 0,
  RESETPASSWORD = 1,
  SENDMAIL = 2
}
